import React, { useState } from "react";
import {Button, Form, Container, Alert, Card, InputGroup} from "react-bootstrap";

const AmazonLinkParser = ({ onExtract }) => {
    const [inputUrl, setInputUrl] = useState("");
    const [asin, setAsin] = useState("");
    const [keywords, setKeywords] = useState("");
    const [error, setError] = useState("");

    const extractAsinAndKeywords = (url) => {
        try {
            const urlObj = new URL(url);
            const pathParts = urlObj.pathname.split("/");
            const queryParams = new URLSearchParams(urlObj.search);

            // Извлекаем ASIN (обычно после "/dp/")
            const asinIndex = pathParts.indexOf("dp");
            const extractedAsin = asinIndex !== -1 ? pathParts[asinIndex + 1] : "";

            // Извлекаем keywords из параметров
            const extractedKeywords = queryParams.get("keywords") || "Not found";

            if (!extractedAsin) {
                throw new Error("ASIN not found in the URL.");
            }

            setAsin(extractedAsin);
            setKeywords(extractedKeywords);
            setError("");

            // Передача данных в родительский компонент
            if (onExtract) {
                onExtract({ asin: extractedAsin, keywords: extractedKeywords });
            }
        } catch (e) {
            setError("Invalid Amazon URL. Please check the link.");
            setAsin("");
            setKeywords("");
        }
    };

    return (
        <>
            <Form>
                <InputGroup className="mb-0 border-success">
                    <Form.Control
                        size="sm"
                        type="text"
                        placeholder="Paste Amazon link here..."
                        value={inputUrl}
                        onChange={(e) => setInputUrl(e.target.value)}
                        className="border-success "
                    />

                <Button
                    variant="success"
                    className="d-flex btn-sm align-items-center"
                    onClick={() => extractAsinAndKeywords(inputUrl)}
                >
                    Check
                </Button>
            </InputGroup>
        </Form>

            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            {asin && (
                <Alert variant="info" className="mt-2">
                    <strong>The trampoline is working!</strong>
                </Alert>
            )}
        </>
    );
};

export default AmazonLinkParser;
